<template>
	<div class="offcn-teacher-login">
		<div class="offcn-main-login">
			<p class="offcn-live-title"><img src="./livelog.png">中公互动课堂</p>
			<div class="offcn-live-message">
				<p>课程ID&nbsp;&nbsp;&nbsp;&nbsp;：{{classinfo.room_num}}</p><p>课程名称：{{classinfo.room_name}}</p>
				<p>课程时间：{{classinfo.start_time}} ~ {{endTime}}</p>
			</div>
			<div class="offcn-live-user">
				<span class="offcn-live-icon offcn-live-icon-left offcn-live-icon-user"></span>
				<input @input="checkLen" class="offcn-live-teacher-name" maxlength="15" type="text" placeholder="请输入姓名">
			</div>
			<button class="offcn-live-log-in" @click='check' disabled>登 录</button>
			<p class="offcn-live-hotline">登录遇到问题请联系： 400-900-8885</p>
		</div>
	</div>
</template>

<script>
import $ from 'jquery'
export default {
  data () {
    return {
      classinfo: [],
      status,
      disabled: 0,
      endTime: ''
    }
  },
  watch: {
  	'$route' (to, from) {
  		if (to.query.password !== from.query.password) {
  			window.location.reload()
  		}
  	}
  },
  methods: {
  	login () {
      const query = this.$route.query
      let loginParams = Object.assign({}, query, {
        password: query.password
      })
  		this.$api.GETROOM(loginParams).then((res) => {
		  	if (res.code === 0) {
		  		this.classinfo = res.data
			  	this.status = res.data.status
          this.disabled = res.data.is_disabled
          if (this.classinfo.start_time.slice(0, 11) === this.classinfo.end_time.slice(0, 11)) {
            this.endTime = this.classinfo.end_time.slice(11)
          } else {
            this.endTime = this.classinfo.end_time
          }
			  	console.log(res.data)
			  	if (res.data.student_password === this.$route.query.password) {
		  			this.$router.push({path: '*'})
		  		} else if (this.disabled === 1) {
		  			this.$router.push({path: 'disabled', query: {password: this.$route.query.password}})
		  			console.log('disabled')
		  		} else if (this.status === 0) {
		  			this.$router.push({path: 'uncompelete', query: {password: this.$route.query.password}})
		  			console.log('uncompelete')
		  		}
		  	} else {
		  		this.$router.push({path: '*'})
		  	}
		  })
    },
    checkLen (e) {
      if (e.target.value !== '') {
        $('.offcn-live-log-in').attr('disabled', false)
        $('.offcn-live-log-in').css({'background': '#ff895f', 'cursor': 'pointer'})
      } else {
        $('.offcn-live-log-in').attr('disabled', true)
        $('.offcn-live-log-in').css({'background': '#ffac8f', 'cursor': 'not-allowed'})
      }
    },
    focus () {
      $('.offcn-live-teacher-name').keyup(function () {
        if ($(this).val() !== '') {
          $('.offcn-live-log-in').attr('disabled', false)
          $('.offcn-live-log-in').css({'background': '#ff895f', 'cursor': 'pointer'})
        } else {
          $('.offcn-live-log-in').attr('disabled', true)
          $('.offcn-live-log-in').css({'background': '#ffac8f', 'cursor': 'not-allowed'})
        }
      })
    },
  	check () {
  		console.log(this.status)
      // this.$router.push({path: 'launch', query: {password: this.$route.query.password, nickname: $('input').val()}})
      this.$router.push({path: 'launch', query: Object.assign({}, this.$route.query, {nickname: $('input').val()})})
  	}
  },
  mounted () {
  	this.login()
  	this.focus()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	.offcn-teacher-login
	{
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background: url('./allbackground.png') no-repeat;
		/*background-position: center;*/
		background-size: cover;
	}
	.offcn-main-login
	{
		width: 485px;
		height: 464px;
		background: #fcfcfc;
		border-radius: 4px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		box-shadow: 0px 0px 20px 0px rgba(255, 60, 0, 0.2);
	}
	.offcn-live-title
	{
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 68px;
		font-size: 28px;
		font-weight: 600;
		img
		{
			margin-right: 16px;
		}
	}
	.offcn-live-message
	{
		margin: 0 60px;
		margin-top: 30px;
		font-size: 14px;
		line-height: 26px;
		color: #737885;
	}
	.offcn-live-user
	{
		position: relative;
	}
	.offcn-live-icon
	{
		background: url(offcn_live_icon.png) no-repeat;
		display: inline-block;
		position: absolute;
	}
	.offcn-live-icon-left
	{
		top: 14px;
		left: 77px;
	}
	.offcn-live-icon-user
	{
	    height: 20px;
	    width: 18px;
	    background-position: 0 -40px;
	}
	.offcn-live-teacher-name
	{
		display: block;
		width: 321px;
		height: 48px;
		margin: 0 auto;
		margin-top: 56px;
		padding-left: 43px;
		border: 1px solid #e6e6e6;
		border-radius: 4px;
		outline: none;
		color: #737885;
	}
	.offcn-live-log-in
	{
		display: block;
		width: 365px;
		height: 50px;
		color: #ffffff;
		font-size: 20px;
		margin: 0 auto;
		margin-top: 40px;
		border-width: 0;
		border-radius: 4px;
		background: #ffac8f;
		outline: none;
    cursor: not-allowed;
	}
	.offcn-live-hotline
	{
		position: absolute;
		left: 50%;
		transform: translate(-50%);
		bottom: -27px;
		color: #737885;
		font-size: 14px;
	}
</style>



// WEBPACK FOOTER //
// src/components/offcn-teacher-login-rtc/login.vue